if (!customElements.get('featured-flavors')) {
  customElements.define(
    'featured-flavors',
    class FeaturedFlavors extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        this.addEventListener('change', e => {
          if (!e.target.closest('input[type="radio"][data-color-picker]')) return;
          const targetId = e.target.value;
          this.querySelectorAll('[data-content]').forEach(el => {
            const thisId = el.dataset.content;
            if (thisId === targetId) {
              el.style.display = null;
            } else {
              el.style.display = 'none';
            }
          })
        })
      }
    }
  )
}